import Service from "../../Service";

const resource = "visit/";

export default {
    
    save(parameters, requestID) {
        return Service.post(resource + "saveApplication", parameters, {
            params: {
                requestID: requestID,
            },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "paginationApplication", parameters, {
            params: { requestID }
        });
    },
    listProductApplication(parameters, requestID) {
        return Service.post(resource + "listVisitProductApplication", parameters, {
            params: { requestID }
        });
    }
};